export const getMerchandisingCategoriesData = ({ state }) =>
  state.merchandising.merchandisingCategoriesData;
